export const actions = {
    START_FETCH_LATEST_EDITS: "START_FETCH_LATEST_EDITS",
    SUCCESSFUL_FETCH_LATEST_EDITS: "SUCCESSFUL_FETCH_LATEST_EDITS",
    FAILED_FETCH_LATEST_EDITS: "FAILED_FETCH_LATEST_EDITS",
};

export const initialState = {
    listingFetching: false,
    listingResponse: [],
};

export default (state = initialState, { type, response }) => {
    switch (type) {
        case actions.START_FETCH_LATEST_EDITS: {
            return {
                ...state,
                listingFetching: true,
            };
        }
        case actions.SUCCESSFUL_FETCH_LATEST_EDITS: {
            return {
                ...state,
                listingFetching: false,
                listingResponse: response,
            };
        }
        case actions.FAILED_FETCH_LATEST_EDITS: {
            return {
                ...state,
                listingFetching: false,
                listingResponse: response,
            };
        }
        default:
            return state;
    }
};
